import { useContext } from 'react';
import { FeedbackIcon, HelpIcon, NotifIcon } from '../../assets/icons/HeaderIcons';
import OpenIcon from '../../assets/icons/OpenIcon';

import { AuthContext } from '../../contexts/AuthContext';
import AvatarImage from '../../ui/AvatarImage';
import { useLocation, useNavigate } from 'react-router-dom';
import Modal from '../../ui/Modal';
import FeedbackModal from './FeedbackModal';
import WalletConnectButton from '../../features/walletconnectUI/WalletConnectButton';
import { fontWeight, height, lineHeight } from '@mui/system';
import Notifications from '../../ui/Notifications';
import { useNotifications } from '../../contexts/NotificationsContext';
import ThemeToggleButton from '../../ui/ThemeToggleButton';

export default function ToptabBar({ showSidebar, toggle }) {
    const { state } = useContext(AuthContext);
    const { user } = state;
    const userProfile = user[0];
    const navigate = useNavigate();
    const { pathname } = useLocation();

    return (
        <div
            className={`flex  ${pathname === '/'
                ? 'bg-bg600'
                : pathname === '/greenpill' ||
                    pathname === '/greenpill/leaderboard' ||
                    pathname === '/greenpill/activityHistory'
                    ? 'bg-bg500Pill'
                    : 'bg-bg500'
                }  z-[99] p-2 sticky top-0 h-[4.1rem] shadow-sm  border-b-2 border-primaryBorder justify-between md:justify-end`}
        >
            <button className={`md:hidden border border-primaryBorder p-2 rounded-md `} onClick={toggle}>
                {showSidebar ? '' : <OpenIcon />}
            </button>

            {/* <WalletConnectButton
                backgroundColor="#fff"
                widthPer="173px"
                customStyles={{
                    color: '#6B7280',
                    fontWeight: 500,
                    height: '32px',
                    paddingTop: '8px',
                    paddingBottom: '8px',
                }}
            /> */}

            <div className="flex items-center gap-4 px-4 py-2">
                <ThemeToggleButton />
                <Modal>
                    <Modal.Button className="flex gap-2 cursor-pointer items-center" opens={'feedback'}>
                        <FeedbackIcon />
                    </Modal.Button>
                    <Modal.Window name={'feedback'}>
                        <FeedbackModal />
                    </Modal.Window>
                </Modal>

                <HelpIcon
                    onClick={() => {
                        navigate('/faqs');
                    }}
                />
                <Notifications />
                <AvatarImage
                    className="cursor-pointer"
                    onClick={() => {
                        navigate('/profile');
                    }}
                    w="w-8"
                    h="h-8"
                    url={userProfile?.profileImage}
                />
            </div>
        </div>
    );
}

// className={`flex  ${
//     pathname === '/'
//         ? 'bg-[#F3F3EB]'
//         : pathname === '/greenpill' ||
//           pathname === '/greenpill/leaderboard' ||
//           pathname === '/greenpill/activityHistory'
//         ? 'bg-[#272727]'
//         : 'bg-gray-100'
// }
